import React from 'react';
import BinIcon from '../../../assets/icons/BinIcon';
import { type } from 'os';
import { Loading } from '../../common/Table/Loading';
import cx from 'classnames';
import { IInventory} from '../../../@types';
import { Link } from 'react-router-dom';

export type TableItem = {
  [key: string]:
    | string
    | number
    | boolean
    | React.ReactElement<any, string | React.JSXElementConstructor<any>>
    | React.ReactFragment
    | React.ReactPortal
    | null
    | undefined;
};

type BodyType = {
  inventory?: IInventory[];
  data: TableItem[];
  // head: { title?: string; icon?: any };
  isLoading: boolean;
  showPagination: boolean;
  tableHead?: any
};

const ListInventoryBody = ({ data, isLoading, showPagination, tableHead }: BodyType) => {
  return (
    <div className="mt-6 overflow-x-auto rounded-[10px]">
      <table className="w-full text-[14px]">
        <thead className="h-[63px] font-semibold text-white bg-[#044E97] border-b-2 border-gray-200">
          <tr className=" whitespace-nowrap">
            {tableHead.map((head: any) => (
              <th key={head.dataIndex} className={`py-3 px-2 ${head?.className}`}>
                {head.title || head.icon}
              </th>
            ))}
          </tr>
        </thead>
        <tbody className="font-medium text-[16px]">
          {isLoading ? (
            <Loading data={tableHead} />
          ) : (
            data &&
            data.map((data, i) => (
              <tr
                key={i}
                className={cx({
                  'bg-white dark:border-gray-700 dark:bg-gray-800 w-full h-[88px] whitespace-nowrap': i % 2 === 0,
                  'bg-[#044E97]  bg-opacity-10 dark:border-gray-700 dark:bg-gray-800 w-full h-[88px] whitespace-nowrap':
                    i % 2 !== 0,
                })}
              >
                {tableHead.map((item: any) => (
                  <td key={item.name} className={`py-3 px-2 text-center ${item.className}`}>
                    {data[item.dataIndex]}
                  </td>
                ))}
              </tr>
            ))
          )}
        </tbody>
      </table>
      <div className="mb-[56px]"></div>
    </div>
  );
};

export default ListInventoryBody;
